import React from 'react';
import { Button } from '@mantine/core';
import * as oauth from '../oauth.js';

const CLIENT_ID = "8896805571";
const OAUTH_URL = "https://oauth.telegram.org/auth";

const TelegramLoginButton = () => {
  const handleClick = () => {
    const redirectUri = window.location.origin + '/tg-callback';
    const url = `${OAUTH_URL}?` +
      `client_id=${CLIENT_ID}&` +
      `scope=${encodeURIComponent('openid profile telegram:bot_access')}&` +
      `response_type=post_message&` +
      `redirect_uri=${encodeURIComponent(redirectUri)}`;

    const w = 550, h = 470;
    const left = Math.round((window.screen.width - w) / 2);
    const top = Math.round((window.screen.height - h) / 2);
    const popup = window.open(url, 'tg_oauth', `width=${w},height=${h},left=${left},top=${top}`);

    const onMessage = (event) => {
      if (event.origin !== 'https://oauth.telegram.org') return;
      window.removeEventListener('message', onMessage);
      if (popup) popup.close();

      const data = typeof event.data === 'string' ? JSON.parse(event.data) : event.data;
      console.log('TG OAuth postMessage data:', data);

      const tgData = data.result || data;
      oauth.TelegramLoginWidgetAuth({
        tgData,
        onJWTObtained: () => {
          window.location.href = '/';
        }
      }).catch((err) => {
        console.error('TG OAuth failed:', err);
      });
    };
    window.addEventListener('message', onMessage);
  };

  return (
    <Button
      onClick={handleClick}
      variant="default"
      radius="md"
      size="sm"
      leftSection={
        <svg width="20" height="20" viewBox="0 0 240 240" xmlns="http://www.w3.org/2000/svg">
          <circle cx="120" cy="120" r="120" fill="#2AABEE"/>
          <path d="M98 175c-3.9 0-3.2-1.5-4.6-5.2L82 134.8l95-56.8" fill="#C8DAEA"/>
          <path d="M98 175c3 0 4.3-1.4 6-3l16-15.6-20-12" fill="#A9C9DD"/>
          <path d="M100 144.4l48.4 35.7c5.5 3 9.5 1.5 10.9-5.1l19.7-92.8c2-8.1-3.1-11.7-8.4-9.3L60 117.5c-7.9 3.2-7.8 7.6-1.4 9.5l30.4 9.5 70.4-44.4c3.3-2 6.4-.9 3.9 1.3" fill="white"/>
        </svg>
      }
    >
      Log in with Telegram
    </Button>
  );
};

export default TelegramLoginButton;
